/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import { Drawer, Card, Form, Row, Col, Select } from 'antd';
import ActionButtonsBar from '@ui/ActionButtonsBar';
import Loading from '@components/Loading';
import { getOTACodes } from '@services/common';
import Input from '@ui/Input';
import { LocalPersistence } from '@factories/index';
import { updateSecurity } from '@services/amenityservice';

interface editAmenityProps {
  onClose: () => void;
  visible?: boolean;
  setOperation?: (a: string) => void;
  setCurrentRow?: (a: []) => void;
  setDefKey?: (a: string) => void;
  setSingleAmenity?: (a: any) => void;
  setDataSource?: (a: any) => void;
  currentRow:
    | {
        accsecurity: string;
        charge: number;
        currency: string;
        description: string;
        quantity: number;
        securityid: number;
        securitylangid: number;
        type: string;
        typedetail: string;
        uom: string;
      }[]
    | any;
  name?: string;
  data?: { roomid: number; roomlangid: number; capacity: [] };
  meetingroomsid?: number;
  setCurrentLine?: (a: any) => void;
  tableCurrentData: any;
  refreshAmenitie: () => Promise<void>;
}

interface optionType {
  id: number;
  codeType: string;
  codeValue: string;
  codeName: string;
  key: number | string;
}

const AccessibilitySecurityModal = (props: editAmenityProps) => {
  const [form] = Form.useForm();
  const [disableFlag, setDisableFlag] = useState<boolean>(false);
  const [currencyOpts, setCurrencyOpts] = useState([]);
  const [ready, setReady] = useState(false);
  const [currentOptions, setCurrentOptions] = useState<optionType[]>([]);
  const [disabledStatus, setDisabledStatus] = useState(true);

  const { Option } = Select;

  const saveCapacity = async () => {
    try {
      setDisableFlag(true);
      const get_session = new LocalPersistence('session');
      const session: any = await get_session.getSessionPersistence();
      form.validateFields().then(async (value: any) => {
        let data = [];

        // edit
        if (Object.keys(props.currentRow).length > 0) {
          data = props.tableCurrentData.security.filter(
            ({ securityid, securitylangid }: any) =>
              props.currentRow.securityid !== securityid &&
              props.currentRow.securitylangid !== securitylangid
          );
        } else {
          // Add
          const [objectLength] = props.tableCurrentData?.security.map(
            (item: any) => Object.keys(item).length
          );
          data = objectLength > 0 ? props.tableCurrentData?.security : [];
        }

        const body = {
          supplier: session?.supplier,
          propertyId: session?.propertyId,
          property: {
            amenityservice: [
              {
                amsid: props.tableCurrentData?.amsid,
                amslangid: props.tableCurrentData?.amslangid,
                security: [
                  ...data,
                  {
                    accsecurity: value?.accsecurity || null,
                    type: value?.type || null,
                    quantity: value?.quantity || null,
                    typedetail: value?.typedetail || null,
                    uom: value?.uom || null,
                    charge: value?.charge || null,
                    currency: value?.currency || null,
                    description: value?.description || null,
                  },
                ],
              },
            ],
          },
        };

        await updateSecurity(body);
        props.refreshAmenitie();
        setDisableFlag(false);
        props.onClose();
      });
    } catch (error) {
      setDisableFlag(false);
    }
  };

  const deleteCapacity = async () => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();

    const data = props.tableCurrentData.security.filter(
      ({ securityid, securitylangid }: any) =>
        props.currentRow.securityid !== securityid &&
        props.currentRow.securitylangid !== securitylangid
    );

    const body = {
      supplier: session?.supplier,
      propertyId: session?.propertyId,
      property: {
        amenityservice: [
          {
            amsid: props.tableCurrentData?.amsid,
            amslangid: props.tableCurrentData?.amslangid,
            security: [...data],
          },
        ],
      },
    };

    await updateSecurity(body);
    props.refreshAmenitie();
    setDisableFlag(false);
    props.onClose();
  };

  const getAccessibilityOpts = useCallback(async (accsecurity) => {
    switch (accsecurity) {
      case 'Accessibility':
        const PHYRes = await getOTACodes('PHY', '');
        setCurrentOptions(PHYRes?.otacodes);
        break;
      case 'Security':
        const SECRes = await getOTACodes('SEC', '');
        setCurrentOptions(SECRes?.otacodes);
        break;
      default:
        setCurrentOptions([]);
        break;
    }
  }, []);

  useEffect(() => {
    getAccessibilityOpts(props?.currentRow?.accsecurity);
  }, [props]);

  const getCurrencies = useCallback(async () => {
    const opts = await getOTACodes('CUR', '');
    setCurrencyOpts(opts.otacodes);
  }, []);

  useEffect(() => {
    if (props.visible) {
      setTimeout(() => setReady(true), 300);
      setDisableFlag(false);
      getCurrencies();
    } else {
      form.resetFields();
      setReady(false);
      setDisabledStatus(true);
    }
  }, [props.visible]);

  const validateFieldsError = useCallback(() => {
    form
      .validateFields()
      .then((val) => {
        setDisabledStatus(false);
      })
      .catch((e) => {
        setDisabledStatus(e?.errorFields.length > 0);
      });
  }, []);

  return (
    <>
      <Drawer
        title={`${props.name ? props.name + ' - ' : ''} Accessibility/Security`}
        placement="right"
        onClose={props.onClose}
        visible={props.visible}
        width={976}
        afterVisibleChange={() => {
          form.setFieldsValue({
            accsecurity: props.currentRow?.accsecurity,
            charge: props.currentRow?.charge,
            currency: props.currentRow?.currency,
            description: props.currentRow?.description,
            quantity: props.currentRow?.quantity,
            type: props.currentRow?.type,
            typedetail: props.currentRow?.typedetail,
            uom: props.currentRow?.uom,
          });
        }}
      >
        {ready && (
          <Card style={{ marginTop: -15, marginBottom: 65 }}>
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onValuesChange={validateFieldsError}
            >
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item
                    label="Accessibility / Security"
                    name="accsecurity"
                    rules={[]}
                  >
                    <Select allowClear onChange={(value) => {
                        getAccessibilityOpts(value);
                        form.setFieldsValue({
                          type: '',
                        });
                        validateFieldsError();
                      }}
                      showSearch
                      allowClear
                    >
                      <Option value="Accessibility">Accessibility</Option>
                      <Option value="Security">Security</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Type"
                    name="type"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_) {
                          if (
                            getFieldValue('accsecurity') !== undefined &&
                            getFieldValue('type').length === 0
                          ) {
                            return Promise.reject(
                              new Error('This field is required')
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                    >
                      {currentOptions.map((item: any, i) => {
                        return (
                          <Option
                            key={item.codeName}
                            value={item.codeName}
                          >
                            {item.codeName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Quantity"
                    name="quantity"
                    rules={[
                      {
                        required: false,
                        pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                        message: 'This field should be a number',
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Type Detail"
                    name="typedetail"
                    rules={[
                      {
                        max: 50,
                        message:
                          'You have reached the max character length of 50',
                      },
                    ]}
                  >
                    <Input maxLength={50} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Unit of Measure"
                    name="uom"
                    rules={[]}
                  >
                    <Select
                      // onChange={onChangeItem}
                      showSearch
                      allowClear
                    >
                      <Option value="Meters">Meters</Option>
                      <Option value="Millimeters">Millimeters</Option>
                      <Option value="Centimeters">Centimeters</Option>
                      <Option value="Yards">Yards</Option>
                      <Option value="Feet">Feet</Option>
                      <Option value="Inches">Inches</Option>
                      <Option value="Pixels">Pixels</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Charge Amount"
                    name="charge"
                    rules={[
                      {
                        required: false,
                        pattern: /^\d*(\.\d*)?$/,
                        message: 'This field should be a number',
                      },
                    ]}
                  >
                    <Input type="number" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Currency"
                    name="currency"
                  >
                    <Select allowClear showSearch>
                      {currencyOpts.map((item: any, i) => {
                        return (
                          <Option
                            key={item.codeName}
                            value={item.codeName}
                          >
                            {item.codeName}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                      {
                        max: 500,
                        message:
                          'You have reached the max character length of 500',
                      },
                    ]}
                  >
                    <Input maxLength={500} />
                  </Form.Item>
                </Col>
              </Row>
              <br />
            </Form>
            {disableFlag && <Loading type="large" />}
            <ActionButtonsBar
              onCancel={props.onClose}
              onSave={() => saveCapacity()}
              disabledSave={disabledStatus}
              show={true}
              onDelete={
                Object.keys(props.currentRow).length > 0
                  ? () => deleteCapacity()
                  : false
              }
            />
          </Card>
        )}
        {!ready && <Loading type="medium" />}
      </Drawer>
    </>
  );
};

export default AccessibilitySecurityModal;
